import React, { useState, useContext, useEffect, useRef } from "react";
import "./payCustomAmount.scss";
import { useHistory } from "react-router-dom";

// material ui
import Button from '@mui/material/Button';
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
import TextField from '@mui/material/TextField';
import InputMaskField from "../react-input-mask/inputfield"





function PayCustomAmount(props) {
  const { t } = useTranslation();
  const { window,store, subTotal, paidAmount } = props;
  const [open, setOpen] = React.useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
    return [htmlElRef, setFocus]
  }
  const [inputRef, setInputFocus] = useFocus()
  const handleConfirm = () => {
    if (props.splitBillAmount <= props.subTotal) {
      appDispatch({
        type: "setPayCustomAmount",
        payCustomAmount: false,
      });
      appDispatch({
        type: "setSplitBillOptions",
        splitBillOptions: false,
      });
      appDispatch({
        type: "setSplitBill",
        splitBill: true,
      });
      localStorage.removeItem("payCustomAmount")
      localStorage.removeItem("splitBillOptions")
      localStorage.setItem("splitBill", Boolean(true))
      props.setSplitBillAmount(customAmount)
      props.setPartialType("customer")
    } else {
      appDispatch({
        type: "SHOW_ALERT",
        alertType: "error",
        message: `Given amount is wrong`,
      });
      setInputFocus()
    }

  }

  const handleChangeSplit = () => {
    appDispatch({
      type: "setPayCustomAmount",
      payCustomAmount: false,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: true,
    });
    localStorage.removeItem("payCustomAmount")
    localStorage.setItem("splitBillOptions", true)
    props.setSplitBillAmount(0)
    props.setPartialType('')
  }

  const [customAmount, setCustomAmount] = useState(props.splitBillAmount)
  const [remainAmount, setRemainAmount] = useState(subTotal - paidAmount)

  const handleCustomAmount = (event) => {
    const re = /^[.0-9\b]+$/;
    // if(Number(event.target.value) <= parseFloat(subTotal).toFixed(3) || event.nativeEvent.data == null){
      if (event.target.value === '' || event.nativeEvent.data == null || re.test(event.target.value) ) {
        if (event.target.value.includes('.')) {
          if(event.target.value.split('.')[1].length < 3){
            var amount = parseFloat(event.target.value)
            if(event.target.value <=  remainAmount  ){
              props.setSplitBillAmount(event.target.value)
    
              setCustomAmount(event.target.value);
            }
            else{
              appDispatch({
                type: "SHOW_ALERT",
                alertType: "error",
                message: `Amount must be less or equal to ${parseFloat(remainAmount).toFixed(3)}`,
              });
            }
         }
      }else{
        if(event.target.value <=  (remainAmount)  ){
          props.setSplitBillAmount(event.target.value)

          setCustomAmount(event.target.value);
        }
        else{
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "error",
            message: `Amount must be less or equal to ${parseFloat(remainAmount).toFixed(3)}`,
          });
        }
      }
      
    
    // }
  }
    
  };

  useEffect(() => {
    let a = parseFloat(subTotal - paidAmount).toFixed(3)
    if (props.splitBillAmount <= 0) {
      setCustomAmount(a)
    } else {
      setCustomAmount(props.splitBillAmount)
    }
  }, [])



  const formatChars = {
    '9': '[0-9]',
  };
  return (
    <>


      <div id="mySidenav" className={`payCustomAmount ${appState.langValue == "ar" ? "divideBillArabic" : " "
        }`}>
        {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}
        <div className="container-fluid content px-4 pb-3 mt-4">
          <h1 className={` ${appState.langValue === "ar" ? "text-right familyGraphikArabic800 " : " familyPoppins600"
            }`}
          >{t("invoice.How-much-you-want-to-pay")}?</h1>

          <div className="inputFieldParent my-3 py-5">
            <TextField  inputProps={{ max: 3, inputMode: "decimal", pattern: "[0-9]*" }}
              type="decimal"
              value={customAmount }
              label={null}
              variant="outlined"
              ref={inputRef} 
              onChange={(event)=>handleCustomAmount(event)}
              id="outlined-basic" name="phoneNumber"
              autoFocus={true}
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 },
              }}
            /> 
            <h5 className="text-center familyPoppins600">{t(`${store?.currency}`)}</h5>

          </div>
          <div className="bottomBtn">
            <Button
              onClick={handleConfirm}
              disabled={customAmount <= 0}
              className={` py-3 px-4  mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                } ${customAmount <= 0 ? `disabledBtn` : `confirmBtn`}`}
            > <span >{t("invoice.Confirm")}</span>  </Button>
            <Button onClick={handleChangeSplit} className={` py-3 px-4 mt-3 deletebtn justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
              }`}
            > <span >{t("invoice.Delete-Split")}</span>  </Button>
          </div>
        </div>
      </div>
    </>


  );
}



export default withTranslation()(PayCustomAmount);